import { Card, Container, Group } from '@melio/penny';
import React from 'react';

export const PlanSettingContainer = ({ children }: { children: React.ReactNode }) => (
  <Card variant="flat" paddingX="xl" paddingY="xl">
    <Group variant="vertical" spacing="s" width="full">
      <Container>{children}</Container>
    </Group>
  </Card>
);
